type MonthsSpending = {
  totalMinor: number;
  months: { exactMinor: number; estimatedMinor: number }[];
};

type MonthsFooterInput = {
  hasEstimates: boolean;
  exceedsYear: boolean;
};

const ESTIMATES_TEXT = 'Блідіша частина стовпчика — оцінки змінних підписок.';

const EXCEEDS_YEAR_TEXT =
  'Місяці разом дають більше за рік: повернення зменшує свій місяць лише до нуля, а рік — на всю суму.';

export const monthsExceedYear = (spending: MonthsSpending): boolean => {
  const monthsTotal = spending.months.reduce(
    (sum, month) => sum + month.exactMinor + month.estimatedMinor,
    0,
  );

  return monthsTotal > spending.totalMinor;
};

export const monthsFooterOf = ({
  hasEstimates,
  exceedsYear,
}: MonthsFooterInput): string | undefined => {
  const sentences = [hasEstimates ? ESTIMATES_TEXT : null, exceedsYear ? EXCEEDS_YEAR_TEXT : null];
  const kept = sentences.filter((sentence): sentence is string => sentence !== null);

  return kept.length === 0 ? undefined : kept.join(' ');
};
